export default __webpack_public_path__ + "static/media/group-169.4dfe3b9a.png";